interface ComponentOpts {
  className: string;
  content: any;
  style: Partial<CSSStyleDeclaration>;
}

function createElement({ className, content, style }: ComponentOpts) {
  const component = document.createElement('div');
  component.className = className;
  component.innerHTML = content;
  Object.keys(style).forEach((key: any) => {
    const val = style[key];
    if (val) {
      component.style[key] = val;
    }
  });
  return component;
}

let rootElement: HTMLDivElement | null;
const getRootElement = () => {
  if (rootElement) {
    return rootElement;
  }
  rootElement = document.getElementById('coin-container') as HTMLDivElement;
  return rootElement;
};

export function addPointUp(points: number, boosted = false) {
  const rootElement = getRootElement();
  if (!rootElement) {
    return;
  }

  const pos = {
    top: `${Math.random() * 50}px`,
    left: `calc(${2 + Math.random() * 30}vh)`,
  };

  const component = createElement({
    className: `point-up ${boosted && 'boosted'}`,
    content: `+${points}`,
    style: pos,
  });

  rootElement.append(component);

  // After animation ends, remove element
  setTimeout(() => {
    component.remove();
  }, 400);
}

export function addMorseUp(morse: string) {
  const rootElement = getRootElement();
  if (!rootElement) {
    return;
  }

  const pos = {
    top: `${Math.random() * 50}px`,
    left: `calc(${2 + Math.random() * 30}vh)`,
    fontSize: '100px',
  };

  const component = createElement({
    className: `point-up`,
    content: morse,
    style: pos,
  });

  rootElement.append(component);

  // After animation ends, remove element
  setTimeout(() => {
    component.remove();
  }, 400);
}

let rippleNode: Element | null | undefined;
const getRippleNode = () => {
  if (rippleNode) {
    return rippleNode;
  }
  rippleNode = document.getElementById('ripple-templates')?.children[0];
  return rippleNode;
};

export function addRipple() {
  const rippleNode = getRippleNode();
  const rootElement = getRootElement();
  if (rippleNode && rootElement) {
    const clone = rippleNode.cloneNode(true);
    rootElement.append(clone);
    setTimeout(() => {
      (clone as any).remove();
    }, 500);
  }
}
